#import "./fields.graphql"

# Deep link to a requisition that is no longer on the caller's queue.
query inboxRequisitionLookup($searchTerms: [String!]!, $size: Int!) {
  result: searchRequisitions(
    searchTerms: $searchTerms
    size: $size
    page: 1
    activeOnly: false
  ) {
    requisitions {
      ...InboxRequisitionFields
    }
  }
}
